import React from "react";
import PropTypes from "prop-types";

import propTypes from "../../../constants/propTypes";
import { Row, StyledReportList } from "./components";
import { Title } from "../../ui/Typography/SectionTitle";
import Loader from "../../ui/Loader";
import { ProjectReportRow } from "./ProjectReportRow/ProjectReportRow";

const ReportList = ({
  reportsLoader,
  projectReports,
  handleDownloadReport,
  totalReports,
}) => (
  <StyledReportList>
    <Row>
      <Loader width="150px" height="28px">
        <Title>{totalReports} Reports</Title>
      </Loader>
    </Row>
    {projectReports.map(projectReport => (
      <ProjectReportRow
        key={projectReport.id}
        reportsLoader={reportsLoader}
        handleDownloadReport={handleDownloadReport}
        projectReport={projectReport}
      />
    ))}
  </StyledReportList>
);

ReportList.propTypes = {
  handleDownloadReport: PropTypes.func,
  projectReports: PropTypes.array,
  reportsLoader: propTypes.reportsLoader,
  totalReports: PropTypes.number,
};

ReportList.defaultProps = {
  projectReportsLoader: [],
};

export default ReportList;
